// extracted by mini-css-extract-plugin
export default {"box":"XAbBAyHZa5yZWtzp3voe","inputsBlock":"nbqF16NIJ0plbLsAm7Hv","subscriptionsBox":"x90hU3u3jWGX2TbnZoX5"};